import * as React from "react";
import { PageContainer } from "../../../../components";
import { LiveDogs } from "./LiveDogs";
import { DeadDogs } from "./DeadDogs";

export interface IDrupalDogListPageProps {}

export const DrupalDogListPage: React.FunctionComponent<IDrupalDogListPageProps> = () => {
  return (
    <PageContainer>
      <LiveDogs />
      <DeadDogs />
    </PageContainer>
  );
};
